import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Components
import Drawer from '../Drawer/Drawer';

// Material UI Components
import { Paper, Toolbar, IconButton, TextField, Typography, Box, Button, Hidden, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Snackbar, Fade } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

// Icons
import MenuIcon from '@material-ui/icons/Menu';
import DoneIcon from '@material-ui/icons/Done';

// Material UI Custom Style
const useStyles = makeStyles(theme => ({
    SuccessButton: {
        borderColor: "#27AE60",
        color: "#27AE60"
    },
}));

export default function Header( {editMode, currentNote, notes, onClickSave, onClickEditMode, onClickCancelEditor, onClickClearNotes, onClickToggleLock, onClickDeleteNote, onClickOpenNote} ) {
    const Style = useStyles();
    const [title, setTitle] = React.useState("New Note");
    const [drawerOpen, setDrawerOpen] = React.useState(false);

    // Dialog
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogType, setDialogType] = React.useState("");
    const [lockType, setLockType] = React.useState("");
    const [currentNoteChosen, setCurrentNoteChosen] = React.useState(null);
    const [password, setPassword] = React.useState('');
    const [noteId, setNoteId] = React.useState(null);
    const [error, setError] = React.useState(false);

    // Snackbar
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackBarMessage, setSnackBarMessage] = React.useState(false);

    // This method will calculate the length of the title to either display the shorter version or the longer version.    
    const calcLength = (type) => {
        if(type.length > 12){
            return currentNote === null ? title : currentNote.titleDrawer
        }else{
            return currentNote === null ? title : currentNote.title
        }
    }

    // This method will save whatever the user types into the title state
    const handleTitleChange = (event) => {
        if(title.length > 18){
            return
        }else{
            setTitle(event.target.value);
        }
    }

    // This method will handle the title if the user types a title that is longer than 18 characters long a message will display
    const handleTitleMaxLength = (event) => {
        if(title.length > 18){
            if(event.key === "Backspace" || event.key === "Delete"){
                setTitle("");
                event.target.value = "";
            }else{
                event.target.value = "Limit of 18 Characters reached.";
                return
            }
        }else{
            return
        }
    }

    /* 
        This method will handle whenever the save button is pressed. Will set the title to whatever the user typed 
        or to first word if left empty
    */
   const handleSaveButtonAndTitle = () => {
       if(currentNote !== null && (title === "New Note" || title === "")){
           onClickSave(currentNote.title);
        }else{
            onClickSave(title);
        }
        handleSnackbarClick("Save");
    }

    // This will toggle the drawer meaning it will either open/close the drawer
    const toggleDrawer = () => event => {
        setDrawerOpen(!drawerOpen);
        setPassword('');
        setError(false);
    };

    // This method will handle whenever the clear button is pressed. It will promt to user to decide whether or not to clear the notes
    const handleClearNotes = () => {
        setDialogType("Clear");
        setDialogOpen(true);
    }

    // This method will execute the clear notes method to clear the notes and will trigger an alert to notify the user 
    const handleClearNotesYes = () => {
        onClickClearNotes()
        handleSnackbarClick("Clear");
    }

    // This method will execute the delete note method to delete the note and will trigger an alert to notify the user
    const handleDeleteNoteYes = (noteId) => {
        onClickDeleteNote(noteId)
        handleSnackbarClick("Delete");
    }

    /*  
        This method will check whether the note is locked or not, if so then it will promt the user to enter password, 
        then it will render the note on the editor
    */
    const handleCheckNote = (note) => {
        if(note.locked === true){
            setPassword('');
            const newCurrentNote = currentNote || {};
            if(newCurrentNote.id === note.id){
                return
            }else{
                setLockType('');
                setDialogType("Password");
                setCurrentNoteChosen(note);
                setDialogOpen(true);
            }
        }else if(note === "New"){
            setTitle("New Note");
            onClickOpenNote("New");
        }else{
            onClickOpenNote("", note);
        }
    }

    // This method will handle the lock. It will check whether the user wants to unlock or lock the note.
    const handleToggleLock = (note, checkType) => {
        setPassword('');
        setDialogType("Password");
        setError(false);
        setDialogOpen(true);

        if(checkType === "turnOff"){
            setLockType("turnOff");
            setCurrentNoteChosen(note);
        } else if(checkType === "turnOn"){
            setLockType("turnOn");
        } 
        setNoteId(note.id)
    };

    // This method will handle whenever the trash can icon is pressed. It will promt to user to decide whether or not the note is to be deleted
    const handleDeleteNote = (id) =>{
        setDialogType("Delete");
        setNoteId(id)
        setDialogOpen(true);
    }

    // This method will close the dialog
    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    /*  
        This method will handle the password. If the type is turnOff meaning the user wants to unlock the note, it will 
        promt the user to enter the password in order to unlock. Else if it is turnOn meaning the user wants to lock the note, it will 
        promt the user to enter a password in order to lock it.
    */
    const handleNotePassword = () => {
        if(lockType === "turnOff"){
            if(currentNoteChosen.password === password){
                onClickToggleLock(noteId, password, lockType);
                handleSnackbarClick("Unlocked")
            } else{
                setError(true);
                return
            }
        } else {
            onClickToggleLock(noteId, password, lockType);
            handleSnackbarClick("Locked")
        } 
        handleCloseDialog();
    }

    // This method will handle the opening of locked notes. If password match then it will render.
    const handleOpenLockedNote = () => {
        if(currentNoteChosen.password === password){
            onClickOpenNote("", currentNoteChosen);
            handleCloseDialog();
        }else{
            setError(true);
        }
    }

    /*
        This method will handle the keypress. If enter then it will execute the handleURL method 
        else if the escape key is pressed it will execute the handleClose method
    */
    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            if(lockType === "turnOff" || lockType === "turnOn"){
                handleNotePassword()
            }else{
                handleOpenLockedNote()
            }
        } else if(event.key === 'Escape'){
            handleCloseDialog()
        }
    }

    // This method will open the dialog
    const handleSnackbarClick = (type) => {
        setSnackbarOpen(true);
        setSnackBarMessage(type)
    };
    
    // This method will close the dialog
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setSnackbarOpen(false);
    };

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
        <React.Fragment>
            <Paper variant="outlined">
                <Toolbar>
                    <IconButton aria-label="Menu" color="inherit" edge="start" onClick={toggleDrawer()}>
                        <MenuIcon />
                    </IconButton>
                    {
                        editMode === true 
                            ?
                            <React.Fragment>
                                <Hidden smUp>
                                    <TextField onChange={handleTitleChange} onKeyDown={(event) => handleTitleMaxLength(event)} color="primary" fullWidth margin="dense" name="Title" placeholder={currentNote === null ? "Title" : currentNote.title} variant="outlined" style={{margin: "0"}} />
                                </Hidden>
                                <Hidden xsDown>
                                    <TextField onChange={handleTitleChange} onKeyDown={(event) => handleTitleMaxLength(event)} color="primary" margin="dense" name="Title" placeholder={currentNote === null ? "Title" : currentNote.title} variant="outlined" style={{width: "300px", margin: "0"}} />
                                </Hidden>
                            </React.Fragment>   
                                :
                                <React.Fragment>
                                    <Hidden smUp>
                                        <Typography color="inherit" variant="h5">{currentNote === null ? calcLength(title) : calcLength(currentNote.titleDrawer)}</Typography>
                                    </Hidden>
                                    <Hidden xsDown>
                                        <Typography color="inherit" variant="h5">{currentNote === null ? title : currentNote.title}</Typography>
                                    </Hidden>
                                </React.Fragment> 
                    }

                    <Box style={{flex: 1}} />
                    <Box style={{display: editMode === true ? "block" : "none"}} ml={0.5} mr={0.5}>
                        <Button 
                            aria-label="Cancel" 
                            color="default"
                            variant="text"
                            onClick={() => onClickCancelEditor()}>
                            Cancel
                        </Button>
                    </Box>
                    <Button 
                        aria-label={editMode === true ? "Save" : "Edit"} 
                        color={editMode === true ? "inherit" : "primary"}
                        className={editMode === true ? Style.SuccessButton : ""}
                        variant="outlined"
                        onClick={editMode === true ? () => handleSaveButtonAndTitle() : () => onClickEditMode()}
                        disabled={editMode === false ? false : title.length > 18 ? true : false}>
                        {editMode === true ? "Save" : "Edit"} 
                    </Button>
                </Toolbar>
            </Paper>
            <Drawer 
                notes={notes}
                drawerOpen={drawerOpen}
                toggleDrawer={toggleDrawer}
                onClickClearNotes={handleClearNotes}
                onClickDeleteNote={handleDeleteNote}
                onClickOpenNote={onClickOpenNote}
                onClickToggleLock={onClickToggleLock}
                handleToggleLock={handleToggleLock}
                handleCheckNote={handleCheckNote}
            />
            <Dialog
                open={dialogOpen}
                keepMounted
                onClose={handleCloseDialog}
                aria-labelledby="alertTitle"
                aria-describedby="alertDescription"
            >
                <DialogTitle id="alertTitle">
                {
                    dialogType === "Password" ? "Enter Password" : dialogType === "Delete" ? "Delete Note" : dialogType === "Clear" ? "Clear Notes" : "" 
                } 
                </DialogTitle>
                <DialogContent>
                    {
                        dialogType === "Password" 
                            ?   
                            <TextField
                                autoFocus
                                margin="dense"
                                id="password"
                                label="Password"
                                type="password"
                                error={error}
                                onChange={(event) => setPassword(event.target.value)}
                                onKeyPress={(event) => handleKeyPress(event)}
                                value={password}
                                variant="outlined"
                                required
                                fullWidth
                            />
                                : dialogType === "Delete" 
                                    ?   
                                    <DialogContentText id="alertDescription">Are you sure you want to delete this note?</DialogContentText>
                                        : dialogType === "Clear" 
                                            ?   
                                            <DialogContentText id="alertDescription">Are you sure you want to clear the notes?</DialogContentText>
                                                : null
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="default">
                        {
                            dialogType === "Password" ? "Cancel" : dialogType === "Delete" || dialogType === "Clear" ? "No" : "" 
                        }
                    </Button>
                    {
                        dialogType === "Password" 
                            ?   
                            <Button disabled={password === "" ? true : false} onClick={lockType === "turnOff" || lockType === "turnOn" ? handleNotePassword : handleOpenLockedNote} color="primary">
                                Submit
                            </Button>
                                : dialogType === "Delete" || dialogType === "Clear" 
                                    ?   
                                    <Button onClick={dialogType === "Delete" ? () => handleDeleteNoteYes(noteId) : () => handleClearNotesYes()} onMouseDown={handleCloseDialog} color="secondary">
                                        Yes
                                    </Button>
                                        : null
                    }
                </DialogActions>
            </Dialog>
            <Snackbar 
                open={snackbarOpen} 
                autoHideDuration={5000} 
                onClose={handleSnackbarClose}
                TransitionComponent={Fade}
                transitionDuration={{enter: 100, exit: 1000}}
            >
                <Alert 
                    onClose={handleSnackbarClose} 
                    severity="success"
                    variant="filled"
                    icon={<DoneIcon />}
                >
                    {
                        snackBarMessage === "Save"
                            ?   "Note has been successfully saved!"
                                : snackBarMessage === "Clear" 
                                    ? "Notes have been successfully cleared!"
                                        : snackBarMessage === "Delete" 
                                            ? "Note has been successfully deleted!"
                                                : snackBarMessage === "Locked" 
                                                    ? "Note has been successfully locked"
                                                        : snackBarMessage === "Unlocked" 
                                                            ? "Note has been successfully unlocked"
                                                                : ""
                    }
                </Alert>
            </Snackbar>
        </React.Fragment>
    )
}
